import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import AssignmentsIcon from "../../../../../assets/Images/grade_book_assignments.png";
import withStyles from '@mui/styles/withStyles';

import {
  Card,
  CardHeader,
  Button,
  Typography,
  Avatar,
  CardContent,
  Divider,
  CardActions,
  List,
  ListItem,
  ListItemText,
  Link,
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import ProfilePlaceHolder from "../../../../../assets/Images/ProfilePlaceholder.png";
import FeeVouchersDialog from "../../../../../components/FeeVouchersDialog/FeeVouchersDialog";

const styles = () => ({
  smallAvatar: {
    width: 30,
    height: 30,
    marginTop: 12,
    marginRight: 15,
    marginLeft: "-15px",
  },
  action: {
    display: "flex",
  },
  handCursor: {
    cursor: "pointer",
    listStyleType: "square",
  },
});

const Profile = (props) => {
  const classes = props.classes;
  const lmsData = localStorage.getItem("lmsData") ? JSON.parse(localStorage.getItem("lmsData")) : {};
  const lmsStudentId = localStorage.getItem("lmsStudentId") ? JSON.parse(localStorage.getItem("lmsStudentId")) : {};
  const [avatarUrl, setAvatarUrl] = React.useState(null);
  const [isVouchersDialogOpen, setIsVouchersDialogOpen] = React.useState(false);

  const fetchFileAsDataUrl = async (filePathWithName) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/CommonFileViewByFullPath?filePathWithName=${encodeURIComponent(filePathWithName)}`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      },
    });
    if (!res.ok) {
      if (res.status === 401) throw new Error("Unauthorized");
      return null;
    }
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  React.useEffect(() => {
    let isMounted = true;
    const loadAvatar = async () => {
      try {
        if (lmsData.profilePhotoUrl) {
          const dataUrl = await fetchFileAsDataUrl(lmsData.profilePhotoUrl);
          if (dataUrl && isMounted) setAvatarUrl(dataUrl);
        }
      } catch (err) {
        console.error("Error loading avatar:", err);
      }
    };
    loadAvatar();
    return () => { isMounted = false; };
  }, [lmsData.profilePhotoUrl]);

  console.log("studentShowGradeBookStatus", localStorage.getItem("studentShowGradeBookStatus"))
  return (
    <Fragment>
      <FeeVouchersDialog
        open={isVouchersDialogOpen}
        handleClose={() => setIsVouchersDialogOpen(false)}
      />
      <Card style={{ height: '100%' }}>
      <CardHeader
        // <div className={classes.imageContainer} style={{
        //   backgroundImage: `url(${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01AdmissionsProspectApplicationImageView?fileName=${data.imageName})`,
        // }}
        //avatar={<Avatar aria-label="Recipe" src={ProfilePlaceHolder} />}
        avatar={
          <Avatar
            aria-label="ProfileImage"
            src={avatarUrl || ProfilePlaceHolder}
          />
        }
        action={
          <IconButton size="large">
            <MoreVertIcon />
          </IconButton>
        }
        title={lmsData.displayName || "Student"}
        subheader={lmsData.degreeProgramme || "N/A"}
      />
      <div
        style={{
          fontSize: "13px",
          marginLeft: "20%",
          color: "#757575",
        }}
      >
        Todays Check-in :{" "}
        {props.backendData?.DATA?.length > 0 &&
          props.backendData?.DATA[0]?.todaysAttendance !== 0 ? (
          <span
            style={{
              color: "#1579AB",
            }}
          >
            {props.backendData.DATA[0].todaysAttendance}
          </span>
        ) : (
          <span
            style={{
              color: "red",
            }}
          >
            No Check-in
          </span>
        )}
      </div>
      {/* <div
        style={{
          marginTop: "15px",
        }}
      >
        <Link
          href="#/dashboard/R338AttendanceDailyReport"
          target="_blank"
          variant="body1"
          className={classes.handCursor}
          style={{
            fontSize: "14px",
            marginLeft: "20%",
            borderRadius: "5px",
            // color: "#757575",
            padding: "10px 25px",
            background: "#1579AB",
            color: "white",
            textDecoration: "none",
          }}
        >
          Track Gate Attendance
        </Link>
      </div> */}
      <CardContent style={{ paddingBottom: 0 }}>
        <Typography variant="caption">Quick Links</Typography>
        <Divider variant="fullWidth" />
        <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
          {lmsData.feeDueDateStatus !== 0 ? (
            <Link
              onClick={() => props.onFeeAnnouncementClick && props.onFeeAnnouncementClick()}
              variant="body2"
              className={classes.handCursor}
              style={{ color: "#b22c2c", fontWeight: "bold" }}
            >
              Pay Tuition Fee
            </Link>
          ) : (
            <Link
              href="#/dashboard/TutionFeePayment/0"
              target="_blank"
              variant="body2"
              className={classes.handCursor}
            >
              Pay Tuition Fee
            </Link>
          )}
        </div>
        <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
          <Link
            onClick={() => setIsVouchersDialogOpen(true)}
            variant="body2"
            className={classes.handCursor}
          >
            Show Fee Vouchers
          </Link>
        </div>
        <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
          <Link href="#/dashboard/R110Reports" target="_blank" variant="body2" className={classes.handCursor}>
            Timetable
          </Link>
        </div>
        {lmsData.email !== "danish.yazdani@live.com" ?
          ''
          :
          <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <Link onClick={() => props.getCouresData()} variant="body2" className={classes.handCursor}>
              Course Selection
            </Link>
          </div>}

        <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
          <Link href="#/dashboard/R114Reports" target="_blank" variant="body2" className={classes.handCursor}>
            Attendance
          </Link>
        </div>
        <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
          <Link href="#/dashboard/F111Form/0" target="_blank" variant="body2" className={classes.handCursor}>
            Class Discussion
          </Link>
        </div>
        {/* && lmsStudentId.studentId==200076 */}
        {lmsData.feedBackRequired !== 0 &&
          <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <Link href="#/dashboard/F115Form/0" target="_blank" variant="body2" className={classes.handCursor}>
              Feedback
            </Link>
          </div>
        }
        {localStorage.getItem("studentShowGradeBookStatus") == 1 &&
          <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <Link
              href="#/dashboard/R301StudentProgressApprovedReport"
              target="_blank"
              variant="body2"
              className={classes.handCursor}
            >
              Student Grade Book
            </Link>
          </div>
        }
        <br />
        <Typography variant="caption">Announcements</Typography>
        <Divider variant="fullWidth" />
        <div
          style={{
            paddingLeft: "10px",
            marginTop: "5px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.anouncementData.map((item, index) => {
            if (index < 5) {
              return (
                <Fragment key={item.label + index}>
                  <Link onClick={() => props.onAnnouncementClick(item)} variant="body2" className={classes.handCursor}>
                    <div style={{
                      width: 200,
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap'
                    }}> {item.label}</div> <span style={{
                      fontSize: 12,
                      color: 'grey',
                      float: 'right',
                      marginTop: 5
                    }}>{item.anouncementDate}</span>
                  </Link>
                  <br />
                </Fragment>
              );
            }
          })}
        </div>
        <br />

        <Typography variant="caption">Enrolled Courses</Typography>
        <Divider variant="fullWidth" />

        <List style={{ marginLeft: "-5px" }}>
          {props.coursesData.map((item, index) => {
            console.log(item, "item is coming");
            if (index < 6) {
              return (
                <ListItem
                  key={index}
                  style={{ marginBottom: "-5px" }}
                  alignItems="flex-start"
                >
                  <Avatar
                    alt="Remy Sharp"
                    src={AssignmentsIcon}
                    className={classes.smallAvatar}
                  />
                  <ListItemText
                    primary={
                      <Typography
                        component="legend"
                        color="textPrimary"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          localStorage.setItem("selectedCourseLabel", item.courseLabel || "Course");
                          window.open("#/dashboard/CourseHomePage/" + item.id);
                        }}
                      >
                        {item.courseLabel || "heloworld my course"}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography variant="caption" color="textSecondary">
                          {`Course Code: ${item.courseCode}`}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
              );
            }
          })}
        </List>
      </CardContent>
      <Divider variant="middle" />
      <CardActions className={classes.action}>
        <Button
          disabled
          color={"primary"}
          style={{ marginLeft: "auto", textTransform: "none" }}
        >
          View All
        </Button>
      </CardActions>
    </Card>
    </Fragment>
  );
};

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
  coursesData: PropTypes.array,
  anouncementData: PropTypes.array,
  onAnnouncementClick: PropTypes.func,
  backendData: PropTypes.object,
  onFeeAnnouncementClick: PropTypes.func,
};

Profile.defaultProps = {
  coursesData: [],
  anouncementData: [],
  onAnnouncementClick: (fn) => fn,
  backendData: { DATA: [] },
  onFeeAnnouncementClick: (fn) => fn,
};

export default withStyles(styles)(Profile);
